// Existing bookmarks and saved enquiries keep working after the package rename.
export const resolvePackageId = (id) => id === "premium-advisory" ? "strategic-finance" : id;
export const serviceDisplayName = (name) => name?.trim().toLowerCase() === "premium advisory" ? "Strategic Finance" : name;